import axios from 'axios';
const authApiUrl = process.env.VUE_APP_API_URL;

const state = {
  token: localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null,
  accountType: localStorage.getItem('acc') || null,
  recruiterProfile: {},
  recruiterUserProfile: {},
  /* MESSAGES */
  successMessage: '',
  errorMessage: '',
};

const getters = {
  getToken: state => state.token,
  getRecruiterProfile: state => state.recruiterProfile,
  getRecruiterUserProfile: state => state.recruiterUserProfile,

  /* Errors */
  getErrorMessage: state => state.errorMessage,
};

/* Retrieve Token */
// const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

const actions = {
  retrieveRecruiterProfile({ commit }) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      axios
        .get(`${authApiUrl}/recruiter/profile`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          commit('setRecruiterProfile', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  /* Pipelines */
  /* End Pipelines */
  /* CANDIDATES */
  /* END CANDIDATES */
  /* JOBS */
  /* End Jobs */
  /* Candidate comments */
  /* End Candidate comments */
  /* Dashboard */
  /* End Dashboard */
};

const mutations = {
  setRecruiterProfile: (state, recruiterProfile) => (state.recruiterProfile = recruiterProfile),
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
